export const defaultGameScore = {
  record: [
    { name: "試合日", info: "-" },
    { name: "対戦相手", info: "-" },
    { name: "試合スコア", info: "-" },
    { name: "リーグ名", info: "-" },
    { name: "FP", info: "-" },
    { name: "ゴール", info: "-" },
    { name: "アシスト", info: "-" },
    { name: "シュート", info: "-" },
    { name: "枠内シュート", info: "-" },
    { name: "クロス", info: "-" },
    { name: "決定機パス", info: "-" },
    { name: "正確なパス", info: "-" },
    { name: "被ファール", info: "-" },
    { name: "ファール", info: "-" },
    { name: "タックル", info: "-" },
    { name: "イエローカード", info: "-" },
    { name: "レッドカード", info: "-" },
    { name: "インターセプト", info: "-" },
    { name: "クリーンシート", info: "-" },
    { name: "セーブ", info: "-" },
    { name: "失点", info: "-" },
    { name: "勝利", info: "-" },
    { name: "PKセーブ", info: "-" },
  ],
};
